import { NAME } from './constants';

export const INITIALIZE_FORM = `${NAME}/INITIALIZE_FORM`;

export const RESET_FORM = `${NAME}/RESET_FORM`;

export const SEND_MESSAGE = `${NAME}/SEND_MESSAGE`;
export const SEND_MESSAGE_FAILURE = `${NAME}/SEND_MESSAGE_FAILURE`;
export const SEND_MESSAGE_SUCCESS = `${NAME}/SEND_MESSAGE_SUCCESS`;
